module.exports = __webpack_public_path__ + "img/XCKLD.2b2ce33b.png";